import { useState } from "react";
import { ParserConfigDto } from "../../types";
import { useNavigate } from "react-router-dom";

export const useParserConfigMenu =  (deviceTypeId: number) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<ParserConfigDto>();
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = (
    event: React.MouseEvent<SVGSVGElement>,
    row: ParserConfigDto
  ) => {
    setAnchorEl(event.currentTarget as unknown as HTMLElement);
    setSelectedRow(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    if (selectedRow) {
      navigate(`/ParserDetail?id=${selectedRow.id}&deviceTypeId=${deviceTypeId ?? ""}`);
    }
    handleCloseMenu();
  };

  const handleEdit = () => {
    setIsUpdateOpen(true);
    handleCloseMenu();
  };

  const handleCloseUpdate = () => {
    setIsUpdateOpen(false);
  };

  return {
    anchorEl,
    selectedRow,
    isUpdateOpen,
    handleMenuClick,
    handleCloseMenu,
    handleView,
    handleEdit,
    handleCloseUpdate,
  };
};
